import React, {useState} from 'react';

import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {ButtonStyle} from 'ui-library/buttons/Button';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import Modal from 'ui-library/modals/Modal';
import {InputChangeEvent} from 'util/Types';

export default function DeactivateAppWarningModal({
  onRequestClose,
  onRequestSubmit,
}: {
  onRequestClose: () => void;
  onRequestSubmit: (shouldProceed: boolean) => void;
}): JSX.Element {
  const [allowDeactivateApp, shouldDeactivateApp] = useState<boolean>(false);
  return (
    <Modal
      title="Deactivate app"
      medium={true}
      buttons={[
        {
          text: 'Cancel',
          cancel: true,
          onClick: () => {
            onRequestSubmit(false);
          },
        },
        {
          text: 'Deactivate and revoke credentials',
          submit: true,
          style: ButtonStyle.NEGATIVE,
          onClick: () => {
            onRequestSubmit(true);
          },
          disabled: !allowDeactivateApp,
        },
      ]}
      onRequestClose={onRequestClose}
    >
      <InlineBanner
        bannerType={InlineBannerType.ERROR}
        text="Deactivating this app will revoke all existing credentials."
      />
      <br /> New credentials must be generated to re-activate this app. <br />
      <br /> Any apps or integrations using existing credentials will no longer be able to authenticate with
      Benchling. <br />
      <br />{' '}
      <CheckboxInput
        id="deactivate-app-confirmation"
        label="I confirm that I want to deactivate this app"
        checked={allowDeactivateApp}
        onChange={(e: InputChangeEvent) => {
          shouldDeactivateApp(e.target.checked);
        }}
      />
    </Modal>
  );
}
